import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const ConversationStarterCategoryListScreen = lazy(
    () => import('../../screens/ConversationStarterCategory/screens/List'),
);
const ConversationStarterCategoryViewScreen = lazy(
    () => import('../../screens/ConversationStarterCategory/screens/View'),
);
const ConversationStarterCategoryCreateScreen = lazy(
    () => import('../../screens/ConversationStarterCategory/screens/Create'),
);
const ConversationStarterCategoryEditScreen = lazy(
    () => import('../../screens/ConversationStarterCategory/screens/Edit'),
);

const ConversationStarterCategoryRoutes = [
    <Route
        exact
        key={routes.CONVERSATION_STARTER_CATEGORY_LIST}
        path={routes.CONVERSATION_STARTER_CATEGORY_LIST}
        render={() => (
            <Authenticated>
                <ConversationStarterCategoryListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.CONVERSATION_STARTER_CATEGORY_VIEW}
        path={routes.CONVERSATION_STARTER_CATEGORY_VIEW}
        render={() => (
            <Authenticated>
                <ConversationStarterCategoryViewScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.CONVERSATION_STARTER_CATEGORY_CREATE}
        path={routes.CONVERSATION_STARTER_CATEGORY_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <ConversationStarterCategoryCreateScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.CONVERSATION_STARTER_CATEGORY_EDIT}
        path={routes.CONVERSATION_STARTER_CATEGORY_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <ConversationStarterCategoryEditScreen />
            </Authenticated>
        )}
    />,
];

export default ConversationStarterCategoryRoutes;
